import { isOversea } from '@/models/common';
const hostname: string = window?.location?.href || '';
let env: EnvType = 'prod';
if (
  hostname.indexOf('pre-') > -1 ||
  hostname.indexOf('pre.3vjia.com:80') > -1
) {
  env = 'pre';
} else if (
  hostname.indexOf('hws-') > -1 ||
  hostname.indexOf('hws.3weijia.com:80') > -1
) {
  env = 'hws';
} else if (hostname.indexOf('dev-plugin-test') > -1) {
  env = 'test';
}
export type EnvType = 'dev' | 'test' | 'hws' | 'pre' | 'prod';
export const ENV: EnvType = env;

export const materialChannelId = '382896282773020702';
export const materialCustomChannelId = '358217046422511692';

// 素材广场接口请求地址
const material_config: any = isOversea
  ? {
      dev: 'https://magiccube-gateway.3weijia.com',
      test: 'https://aihouse-gw-test.3weijia.com',
      hws: 'https://hws-aihouse-gw.3weijia.com',
      pre: 'https://pre-gw.aihouse.com',
      prod: 'https://gw.aihouse.com',
    }
  : {
      dev: 'https://magiccube-gateway.3weijia.com',
      test: 'https://magiccube-gateway-test.3weijia.com',
      hws: 'https://hws-magiccube-gateway.3weijia.com',
      pre: 'https://pre-magiccube-gateway.3vjia.com',
      prod: 'https://magiccube-gateway.3vjia.com',
    };
// 3d服务请求地址
const menus_config: any = isOversea
  ? {
      dev: 'https://open-test.3weijia.com',
      test: 'https://aihouse-gw-test.3weijia.com',
      hws: 'https://hws-aihouse-gw.3weijia.com',
      pre: 'https://pre-gw.aihouse.com',
      prod: 'https://gw.aihouse.com',
    }
  : {
      dev: 'https://open-test.3weijia.com',
      test: 'https://open-test.3weijia.com',
      hws: 'https://hws-open.3weijia.com',
      pre: 'https://pre-open.3vjia.com',
      prod: 'https://open.3vjia.com',
    };
// 素材广场图片地址
const oss_config: any = {
  dev: 'https://test-3vj-designmaterial.3vjia.com/',
  test: 'https://test-3vj-designmaterial.oss-cn-shenzhen-internal.aliyuncs.com/',
  hws: 'https://hws-3vj-designmaterial.oss-cn-shenzhen-internal.aliyuncs.com/',
  pre: 'https://material.3vjia.com/',
  prod: 'https://material.3vjia.com/',
};

// 以图搜图图片地址
// const oss_search_config: any = {
//   dev: 'https://test-3vj-designmaterial.3vjia.com/',
//   test: 'https://test-3vj-designmaterial.3vjia.com/',
//   hws: 'https://hws-3vj-designmaterial.oss-cn-shenzhen-internal.aliyuncs.com/',
//   pre: 'https://3vj-designmaterial.3vjia.com/',
//   prod: 'https://3vj-designmaterial.3vjia.com/'
// };

// 模型编辑器
const model_editor: any = {
  dev: 'https://dpp-test.3weijia.com/ext/material_square',
  test: 'https://xr-test.3weijia.com/model-editor',
  hws: 'https://hws-xr.3weijia.com/model-editor',
  pre: 'https://pre-xr.3vjia.com/appModelEditor',
  prod: 'https://xr.3vjia.com/appModelEditor',
};
const work_host = isOversea
  ? {
      dev: 'https://www.aihouse.com/work/material-manager-pc/material-management/personal-material?workAppCode=material-manager-pc',
      test: 'https://www.aihouse.com/work/material-manager-pc/material-management/personal-material?workAppCode=material-manager-pc',
      pre: 'https://www.aihouse.com/work/material-manager-pc/material-management/personal-material?workAppCode=material-manager-pc',
      hws: 'https://www.aihouse.com/work/material-manager-pc/material-management/personal-material?workAppCode=material-manager-pc',
      prod: 'https://www.aihouse.com/work/material-manager-pc/material-management/personal-material?workAppCode=material-manager-pc',
    }
  : {
      dev: 'https://work-dev.3weijia.com',
      test: 'https://work-test.3weijia.com',
      pre: 'https://pre-work.3vjia.com',
      hws: 'https://hws-work.3weijia.com',
      prod: 'https://work.3vjia.com',
    };
// 客服地址
const server_url = {
  dev: 'https://hws-www.3weijia.com/customerservice/bambooroom?device=pc&from=3D_V5.0.5.1.111397&queue=13',
  test: 'https://pre-www.3vjia.com/customerservice/bambooroom?device=pc&from=3D_V5.0.5.1.111396&queue=13',
  hws: 'https://hws-www.3weijia.com/customerservice/bambooroom?device=pc&from=3D_V5.0.5.1.111397&queue=13',
  pre: 'https://pre-www.3vjia.com/customerservice/bambooroom?device=pc&from=3D_V5.0.5.1.111396&queue=13',
  prod: 'https://www.3vjia.com/customerservice/bambooroom?device=pc&from=3D_V5.0.5.104395.1&queue=13',
};

const platformapiMap: any = {
  dev: 'https://platformapi.3weijia.com',
  test: 'https://platformapi-test.3weijia.com',
  hws: 'https://hws-platformapi.3weijia.com',
  pre: 'https://pre-platformapi.3vjia.com',
  prod: 'https://platformapi.3vjia.com',
};

const ucweb_host: any = {
  dev: 'https://ucweb.3vjia.com',
  test: 'https://ucweb.3vjia.com',
  hws: 'https://hws-ucweb.3weijia.com',
  pre: 'https://pre-ucweb.3vjia.com',
  prod: 'https://ucweb.3vjia.com',
};
const materialMap: any = {
  dev: 'https://pre-www.3vjia.com/x/assets/plaza',
  test: 'https://pre-www.3vjia.com/x/assets/plaza',
  hws: 'https://hws-www.3weijia.com/x/assets/plaza',
  pre: 'https://pre-www.3vjia.com/x/assets/plaza',
  prod: 'https://www.3vjia.com/x/assets/plaza',
};

const quanwuMap: any = {
  dev: 'https://pre-www.3vjia.com/x/assets/quanwu',
  test: 'https://pre-www.3vjia.com/x/assets/quanwu',
  hws: 'https://hws-www.3weijia.com/x/assets/quanwu',
  pre: 'https://pre-www.3vjia.com/x/assets/quanwu',
  prod: 'https://www.3vjia.com/x/assets/quanwu',
};
const hardMap: any = {
  dev: 'https://pre-www.3vjia.com/x/assets/hard',
  test: 'https://pre-www.3vjia.com/x/assets/hard',
  hws: 'https://hws-www.3weijia.com/x/assets/hard',
  pre: 'https://pre-www.3vjia.com/x/assets/hard',
  prod: 'https://www.3vjia.com/x/assets/hard',
};

const aluminumMap: any = {
  dev: 'https://pre-www.3vjia.com/x/assets/aluminum',
  test: 'https://pre-www.3vjia.com/x/assets/aluminum',
  hws: 'https://hws-www.3weijia.com/x/assets/aluminum',
  pre: 'https://pre-www.3vjia.com/x/assets/aluminum',
  prod: 'https://www.3vjia.com/x/assets/aluminum',
};
const ossFileMap: any = {
  dev: 'https://hws-3vj-apartmentstyle.oss-cn-shenzhen.aliyuncs.com/configure/pre',
  test: 'https://test-content.oss-cn-shenzhen.aliyuncs.com/configure/pre',
  hws: 'https://hws-3vj-apartmentstyle.oss-cn-shenzhen.aliyuncs.com/configure/pro',
  pre: 'https://3vj-apartmentstyle.3vjia.com/configure/pre',
  prod: 'https://3vj-apartmentstyle.3vjia.com/configure/pro',
};

const miniAppHostMap: any = {
  dev: 'https://miniapp-test.3weijia.com',
  test: 'https://miniapp-test.3weijia.com',
  hws: 'https://hws-miniapp.3weijia.com',
  pre: 'https://pre-miniapp.3vjia.com',
  prod: 'https://miniapp.3vjia.com',
};
const getCostPriceUrl = {
  dev: 'https://brand.3vjia.com',
  test: 'https://brand.3vjia.com',
  // 预发挂了，使用正式的
  hws: 'https://brand.3vjia.com',
  // 预发挂了，使用正式的
  pre: 'https://brand.3vjia.com',
  prod: 'https://brand.3vjia.com',
};

const swhdGatewayMap: any = {
  dev: 'https://pre-swhd-gateway.3vjia.com',
  test: 'https://pre-swhd-gateway.3vjia.com',
  hws: 'https://hws-swhd-gateway.3weijia.com',
  pre: 'https://pre-swhd-gateway.3vjia.com',
  prod: 'https://swhd-gateway.3vjia.com',
};

/** 通过环境 获取不同的变量 */
export const materialConfig = material_config[ENV];
export const ossConfig = oss_config[ENV];
export const menusConfig = menus_config[ENV];
// export const ossSearchConfig = oss_search_config[ENV];
export const modelEditor = model_editor[ENV];
export const workHost = work_host[ENV];
export const serverUrl = server_url[ENV];
export const imgResizeParams =
  '?x-oss-process=image/resize,m_fixed,w_400,h_400/format,webp';
export const platformapiUrl = platformapiMap[ENV];
export const ucwebHost = ucweb_host[ENV];
export const newMaterialUrl = materialMap[ENV];
export const quanwuUrl = quanwuMap[ENV];
export const hardUrl = hardMap[ENV];
export const aluminumUrl = aluminumMap[ENV];
export const ossFileUrl = ossFileMap[ENV];
export const miniAppHost = miniAppHostMap[ENV];
export const miniAppCode = 'ImageAiModels';
export const miniAppUrl = `${miniAppHost}/${miniAppCode}`;
export const costPriceUrl = getCostPriceUrl[ENV];
export const swhdGatewayUrl = swhdGatewayMap[ENV];
